import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding } from '@fortawesome/pro-light-svg-icons';
import { ownership } from 'src/models/ownership';

export const BuyersEmpty: FC = () => {
  const { t } = useTranslation();

  return (
    <figure className={styles.hero}>
      <figcaption className={styles.heroCaption}>
        <h3 className={styles.heroTitle}>
          <span>{t('BuyerProfiles.analyticsHeroTitle')}</span>
          <FontAwesomeIcon icon={faBuilding} className={styles.heroIcon} />
        </h3>
        <p className={styles.heroDesc}>{t('BuyerProfiles.analyticsHeroDesc')}</p>
      </figcaption>
      {!!ownership.images.buyerProfile && (
        <img
          className={styles.heroPic}
          src={ownership.images.buyerProfile}
          alt={t('BuyerProfiles.analyticsHeroTitle')}
        />
      )}
    </figure>
  );
};

export default BuyersEmpty;
